import Phaser from 'phaser';
import BootScene from './scenes/BootScene.js';
import TitleScene from './scenes/TitleScene.js';
import MenuScene from './scenes/MenuScene.js';
import CutsceneScene from './scenes/CutsceneScene.js';
import GameScene from './scenes/GameScene.js';
import Level2CutsceneScene from './scenes/Level2CutsceneScene.js';
import Level2Scene from './scenes/Level2Scene.js';
import CreditsScene from './scenes/CreditsScene.js';
import AnimatedCreditsScene from './scenes/AnimatedCreditsScene.js';
import EditorScene from './scenes/EditorScene.js';

// Re-export constants for convenience
export { GAME_WIDTH, GAME_HEIGHT, PLAYER_SPEED, ZOMBIE_SPEED_SHAMBLER, ZOMBIE_SPEED_CRAWLER, ROCKET_SPEED, BLAST_RADIUS, ROCKET_LIFETIME, HOMING_ROCKETS_MAX, ROCKET_PICKUP_CHANCE, COLORS } from './constants.js';

import { GAME_WIDTH, GAME_HEIGHT } from './constants.js';

export const config = {
  type: Phaser.AUTO,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#1a1a2e',
  pixelArt: true,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, TitleScene, MenuScene, CutsceneScene, GameScene, Level2CutsceneScene, Level2Scene, CreditsScene, AnimatedCreditsScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
};

// Editor configuration - full screen, no physics needed
export const editorConfig = {
  type: Phaser.AUTO,
  width: window.innerWidth,
  height: window.innerHeight,
  parent: 'game-container',
  backgroundColor: '#0a0a0a',
  pixelArt: true,
  scene: [EditorScene],
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    mouse: {
      preventDefaultWheel: false,
    },
  },
};
